// import node module libraries
import { Row, Col, Nav, Tab, Card } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

// import custom components
import FlowsSlider from 'components/marketing/pages/flows/FlowSlider';

const FlowsTabSlider = () => {
	const { t } = useTranslation(); // useTranslation-Hook
	
	return (
		<Row>
			<Col md={12}>
				<Tab.Container defaultActiveKey="all">
					<Card className="bg-transparent shadow-none">
						<Card.Header className="border-0 p-0 bg-transparent">
							<Nav className="nav-lb-tab">
								<Nav.Item className="ms-0">
									<Nav.Link eventKey="all" className="mb-sm-3 mb-md-0">
										{' '}
										{t('All Flows')}
									</Nav.Link>
								</Nav.Item>
								{/* Kategorien für spätere Verwendung
								<Nav.Item>
									<Nav.Link eventKey="store" className="mb-sm-3 mb-md-0">
										Marktplatz
									</Nav.Link>
								</Nav.Item>
								<Nav.Item>
									<Nav.Link eventKey="shopsystem" className="mb-sm-3 mb-md-0">
										Shops & Warenwirtschaft
									</Nav.Link>
								</Nav.Item>
								<Nav.Item>
									<Nav.Link eventKey="other" className="mb-sm-3 mb-md-0">
										Weitere Connectoren
									</Nav.Link>
								</Nav.Item>
								*/}
							</Nav>
						</Card.Header>
						<Card.Body className="p-0">
							<Tab.Content>
								<Tab.Pane eventKey="all" className="pb-4 p-4 ps-0 pe-0">
									<FlowsSlider />
								</Tab.Pane>
								{/* Kategorien für spätere Verwendung
								<Tab.Pane eventKey="store" className="pb-4 p-4 ps-0 pe-0">
									<FlowsSlider category="store"/>
								</Tab.Pane>
								<Tab.Pane eventKey="shopsystem" className="pb-4 p-4 ps-0 pe-0">
									<FlowsSlider category="shopsystem" />
								</Tab.Pane>
								<Tab.Pane eventKey="other" className="pb-4 p-4 ps-0 pe-0">
									<FlowsSlider category="other"/>
								</Tab.Pane>*/}
							</Tab.Content>
						</Card.Body>
					</Card>
				</Tab.Container>
			</Col>
		</Row>
	);
};
export default FlowsTabSlider;
